import { useMemo } from 'react';
import moment from 'moment';

import { Checkbox } from '@fortress-technology-solutions/fortress-component-library/Atoms';

import { HEADERS } from './constants';
import { getPicTransactionCertificationTypeDisplay } from './certificationTypeDisplay';

import { processTableFilterOptions } from '../../utils/table-helpers';

const useBuildFilterOptions = ({ results, certificationTypeProgramName }) => {
  return useMemo(() => {
    const options = {
      certificationType: [],
      status: [],
    };
    if (results) {
      results.forEach((result) => {
        if (result.certificationType) {
          options.certificationType.push(
            getPicTransactionCertificationTypeDisplay(
              result.certificationType,
              certificationTypeProgramName,
            ),
          );
        }
        const statusValue = result.lastGeneratedAt
          ? `Generated at ${moment(result.lastGeneratedAt).format(
              'YYYY.MM.DD',
            )}`
          : '';
        options.status.push(statusValue);
      });
    }

    processTableFilterOptions(options);

    return options;
  }, [results, certificationTypeProgramName]);
};

const useHeaders = ({
  results,
  certificationTypeProgramName,
  checkBoxListProps: { handleSelectDeSelectAllRows },
}) => {
  const filterOptions = useBuildFilterOptions({
    results,
    certificationTypeProgramName,
  });
  return useMemo(() => {
    const headers = [];

    HEADERS.forEach((header) => {
      headers.push({
        ...header,
        filterOptions: header.filterOptions ?? filterOptions[header.id],
      });
    });

    const checkboxHeader = {
      id: 'checkbox',
      label: (
        <Checkbox
          onChange={(e) => handleSelectDeSelectAllRows(e)}
          color="secondary"
          sx={{
            color: 'common.white',
          }}
        />
      ),
    };

    headers.unshift(checkboxHeader);

    return headers;
  }, [filterOptions, handleSelectDeSelectAllRows]);
};

export default useHeaders;
